import { getProductId } from './shopifyContext.ts';

const locale = `${window.Shopify.locale?.split('-')[0] ?? 'en'}-${window.Shopify.country}`;
const activeCurrency = window.Shopify.currency?.active;

export default {
  fields: {
    id: 'id',
    image: 'image',
    title: 'title',
    url: 'url',
    price: 'price',
    /* eslint-disable camelcase */
    variant_ids: 'variant_ids',
    compare_at_price: 'compare_at_price',
    /* eslint-enable camelcase */
  },
  entityIdField: 'variant_ids',
  getItemId() {
    const productId = getProductId();
    if (productId) {
      return `${productId}`;
    }

    console.warn('Product id not found');
    return '';
  },
  dropdownImageWidth: 100,
  dropdownImageHeight: 100,
  searchResultsImageWidth: 300,
  searchResultsImageHeight: 300,
  priceFormatter: activeCurrency
    ? new Intl.NumberFormat(locale, { style: 'currency', currency: activeCurrency })
    : null,
};
